import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaylinkSubscription} from '../../models/paylink-subscription';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../services/environment.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {MyBusiness} from '../../models/my-business';
import {MerchantPaylinkPaymentResponse} from '../../models/merchant-paylink-payment-response';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;
declare var $: any;


@Component({
  selector: 'app-process-payment',
  templateUrl: './process-payment.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./process-payment.component.scss']
})
export class ProcessPaymentComponent implements OnInit {

  loading: any;
  form: FormGroup;
  lang: any;
  submitted: boolean;
  myBusiness: MyBusiness;
  submitting: boolean;
  selectedSubscription: PaylinkSubscription;

  constructor(private loader: GlobalLoaderService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  get f() {
    return this.form.controls;
  }

  get v() {
    return this.form.value;
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    console.log('');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalStyles('/plugins/dropify/dropify.min.css');
    await this.loader.loadExternalStyles('/assets/css/users/account-setting.css');
    console.log('');
    await this.loader.loadExternalScript('/plugins/dropify/dropify.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
    console.log('');
    console.log('');
    await this.loader.loadExternalScript('/assets/js/users/account-settings.js');

    $('.dropify').dropify({
      messages: {
        'default': await this.translate.get('Click to Upload or Drag n Drop').toPromise(),
        'remove': '<i class="flaticon-close-fill"></i>',
        'replace': await this.translate.get('Upload or Drag n Drop').toPromise()
      }
    });
  }


  async ngOnInit() {
    this.submitting = false;
    this.loading = true;

    setTimeout(async () => {
      await this.loadResources();
      this.lang = await this.translate.get('lang').toPromise();
      this.loading = false;
      await this.processPayment();
    }, 1000);

  }

  async processPayment() {
    try {
      let orderNumber = this.activatedRoute.snapshot.queryParams['orderNumber'];
      let transactionNo = this.activatedRoute.snapshot.queryParams['transactionNo'];
      let result: MerchantPaylinkPaymentResponse = await this.api.processMerchantPackagePayment(transactionNo, orderNumber);
      console.log('result', result);
      if (result) {
        await this.showToast(await this.translate.get('My package payment successfully completed').toPromise());
        setTimeout(async () => {
          await this.router.navigateByUrl('/');
        }, 3000);
      }
    } catch (e) {
      this.submitting = false;
      if (e.error.title) {
        this.showToast(await this.translate.get(e.error.title).toPromise());
      } else {
        this.showToast(await this.translate.get('Could not pay my package. Try again').toPromise());
      }
      await this.router.navigateByUrl('/private/settings');
      this.submitted = false;
    }
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }
}
